'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var ARROW_LEFT = exports.ARROW_LEFT = 37;
var ARROW_RIGHT = exports.ARROW_RIGHT = 39;
var BACKSPACE = exports.BACKSPACE = 8;
var DELETE = exports.DELETE = 46;
var ZERO_WIDTH_SPACE = exports.ZERO_WIDTH_SPACE = '\u200B';
var STICKY_LEFT = exports.STICKY_LEFT = 'left';
var STICKY_RIGHT = exports.STICKY_RIGHT = 'right';